import * as React from "react";
import { Stack } from "@mui/material";
import { Header } from "@/components/atoms/Header";
import { colors } from "@/styles/constants";
import MultiAccountList from "./MultiAccountList";
import { MultiAccountDetail } from "./MultiAccountDetails";
import { MultiAccountUi, useMultiAccount } from "@/hooks/useMultiAccount";
import { ExpressFormMenuKey } from "./express-data";

// const STORAGE_KEY = ExpressStoreKey.MultiAccount;
const FORM_STEP_CURRENT_SECTION = ExpressFormMenuKey.Account;

export interface CIMultiAccountForm {
  readonly navAfterAccount: () => void;
  readonly onSectionClick: (section: string) => void;
  readonly updateTemplate: any;
}

export default function MultiAccountForm({
  updateTemplate,
  onSectionClick,
  navAfterAccount,
}: CIMultiAccountForm): React.ReactElement | null {
  const [
    { current, accounts, view },
    updateMAS,
    { onBtnClickBack, multiAccountRemove, onBtnClickAdd },
  ] = useMultiAccount();

  const updateTemplateDelegate = React.useCallback(
    ({ onNext }) => {
      updateTemplate((prev: any) => ({
        ...prev,
        busy: false,
        currentSection: FORM_STEP_CURRENT_SECTION,
        nestedFunc: true,
        onAdd: () => onNext(),
        onSectionClick,
      }));
    },
    [onSectionClick, updateTemplate]
  );

  return (
    <Stack rowGap={2}>
      {view === MultiAccountUi.List && (
        <>
          <Header color={colors.lightTeal} level={2}>
            Your added accounts(s)
          </Header>
          <MultiAccountList
            updateMAS={updateMAS}
            accounts={accounts}
            updateTemplate={updateTemplate}
            goToNextSection={navAfterAccount}
            multiAccountRemove={multiAccountRemove}
            onSectionClick={onSectionClick}
          />
        </>
      )}
      {view === MultiAccountUi.Form && (
        <MultiAccountDetail
          account={current}
          onBtnClickBack={onBtnClickBack}
          onBtnClickAdd={onBtnClickAdd}
          updateTemplate={updateTemplate}
          updateTemplateDelegate={updateTemplateDelegate}
        />
      )}
    </Stack>
  );
}
